"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UIFloatingAlertList = _interopRequireDefault(require("UIComponents/alert/UIFloatingAlertList"));

var _NotificationActions = require("../actions/NotificationActions");

var NotificationList =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(NotificationList, _Component);

  function NotificationList() {
    (0, _classCallCheck2.default)(this, NotificationList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NotificationList).apply(this, arguments));
  }

  (0, _createClass2.default)(NotificationList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          notifications = _this$props.notifications,
          onRemoveNotification = _this$props.onRemoveNotification;
      var floatingAlerts = Object.keys(notifications).map(function (notificationId) {
        var clonedNotification = (0, _extends2.default)({}, notifications[notificationId]); // These properties are only used internally by ReduxMessenger,
        // and should not be passed onto the UIFloatingAlert component

        delete clonedNotification.sticky;
        delete clonedNotification.timeout;
        return clonedNotification;
      });
      return _react.default.createElement(_UIFloatingAlertList.default, {
        alerts: floatingAlerts,
        className: className,
        onAlertClose: function onAlertClose(evt, _ref) {
          var id = _ref.id;
          return onRemoveNotification(id);
        }
      });
    }
  }]);
  return NotificationList;
}(_react.Component);

NotificationList.propTypes = {
  className: _propTypes.default.string,
  notifications: _propTypes.default.object.isRequired,
  onRemoveNotification: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    notifications: state.notifications
  };
};

var actionCreators = {
  onRemoveNotification: _NotificationActions.removeNotification
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionCreators)(NotificationList);

exports.default = _default;
module.exports = exports.default;